import moment from 'moment'
import api from '../../services/service_report'
import apipos from '../../services/service_pos'

export default {
  data () {
    return {
      host_list: [],
      report_data: [],
      host: '',
      startDate: moment(new Date()),
      endDate: moment(new Date()),
      header: {
        headers: {
          'Access-Token': sessionStorage.token
        }
      },
      branch: 0,
      form_data: '',
      form_host: ''
    }
  },
  methods: {
    getHost () {
      apipos.getHostShift(
        sessionStorage.Url,
        this.header,
        result => {
          if (result.response === 'success') {
            this.host_list = result.data
            this.host = this.host_list[0]
            // this.getExpend()
          } else {
            this.alert_msg('warning', 'ดึงข้อมูลจุดขายไม่ได้', result.message)
          }
        },
        error => {
          this.alert_msg('error', 'ข้อมูลไม่ถูกต้อง', error.data.error)
        }
      )
    },
    getExpend () {
      var branch = 0
      if (this.branch !== 0) {
        branch = this.branch.id
      }
      var obj = {
        host_code: this.host.host_code,
        company_id: 1,
        branch_id: 1,
        id: branch,
        begin_date: this.dateFormatDMY2(this.startDate),
        end_date: this.dateFormatDMY2(this.endDate)
      }
      this.$store.commit('Loading')
      api.expenseIncome(
        sessionStorage.Url,
        this.header,
        obj,
        result => {
          this.$store.commit('Loading')
          if (result.response === 'success') {
            this.report_data = result.data
            this.form_data = JSON.stringify(this.report_data)
          } else {
            this.alert_msg('warning', 'ดึงข้อมูลรายงานไม่ได้', result.message)
          }
        },
        error => {
          this.alert_msg('error', 'ข้อมูลไม่ถูกต้อง', error.data.error)
          this.$store.commit('Loading')
        }
      )
    },
    timeFormat (str) {
      return moment(str).format('HH:mm:ss')
    },
    count_expen (obj) {
      var sum = 0
      obj.forEach(val => {
        sum += val['amount']
      })
      return sum
    }
  },
  mounted () {
    this.getHost()
    this.getBranch()
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/report_income.js